<template lang="pug">
  div
    b-row
      ReloadAppDialog(:showDialog="showDialog")
      b-col(md='1', offset-md='1')
        b-btn(v-if="$isAllowed('createOperator')",variant="primary", @click="createOperator") Nuevo
      b-col(md="4", offset-md="5")
        b-form-input(type="text" v-model="search" placeholder="Filtrar")
    b-row.justify-content-md-center
      b-col(md="10")
        b-table(hover ,:fields="operatorFields" ,:items="filteredOperators" ,@row-clicked="loadOperator")
      b-modal.operatorModal(v-model="modalShow", :busy="true", size="lg")
        b-form.form-horizontal
          b-row
            b-col(md='6')
              b-form-group(label="Nombre")
                b-form-input.form-control(v-model="operator.name" name="operator[name]" type="text")
              b-form-group(label="Correo electrónico")
                b-form-input.form-control(v-model="operator.email" name="operator[email]" type="email")
              b-form-group(label="Teléfono")
                b-form-input.form-control(v-model="operator.phone" name="operator[phone]" type="text")
              b-form-group(label="Contacto")
                b-form-input.form-control(v-model="operator.contact" name="operator[contact]" type="text")
              b-form-group(label="Remitente")
                selectize(v-model="operator.user_id" name="operator[user_id]" placeholder="Seleccione un remitente")
                  option(v-for="user in err" ,:value="user.id" ,:key="user.id") {{ user.name }}
              b-form-group
                b-form-checkbox(v-model="operator.auto" value="true") Enviar correo automáticamente
              b-form-group
                b-form-checkbox(v-model="operator.reminder" value="true") Activar recordatorios
              b-form-group(label="Id BOB")
                b-form-input.form-control(v-model="operator.internal_id" name="operator[internal_id]" type="text")
            b-col(md='6')
              b-form-group(label="Inicio notificación")
                vue-editor(v-model="operator.opening" id="operator-opening" ,:editorToolbar="customToolbar")
              b-form-group(label="Fin notificación")
                vue-editor(v-model="operator.ending" id="operator-ending" ,:editorToolbar="customToolbar")
              b-form-group(label="Inicio recordatorio")
                vue-editor(v-model="operator.reminder_opening" id="operator-opening-reminder" ,:editorToolbar="customToolbar")
              b-form-group(label="Fin recordatorio")
                vue-editor(v-model="operator.reminder_ending" id="operator-ending-reminder" ,:editorToolbar="customToolbar")
        div(slot="modal-footer")
          b-btn(variant="secondary", @click="closeModal") Cancelar
          b-btn(v-if="action==='create'", variant="primary", @click="registerOperator") Registrar
          b-btn(v-if="action==='update'", variant="primary", @click="updateOperator") Actualizar
</template>

<script>
/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
import kexaApi from '@/services/apiService';
import operatorsPerimeter from '@/perimeters/operatorsPerimeter';
import Selectize from 'vue2-selectize';
import { VueEditor } from 'vue2-editor';

export default {
  name: 'operators',
  components: {
    Selectize,
    VueEditor,
  },
  data() {
    return {
      operatorFields: {
        name: {
          label: 'Nombre',
          sortable: true,
        },
        auto: {
          label: 'Envío automático',
          sortable: true,
        },
        email: {
          label: 'Correo Electrónico',
          sortable: true,
        },
        asignee: {
          label: 'Remitente',
          sortable: true,
        },
        reminder: {
          label: 'Recordatorio',
          sortable: true,
        },
      },
      operators: [],
      err: [],
      operator: {},
      modalShow: false,
      action: null,
      search: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
        ],
      ],
      showDialog: false,
      intervalId: null,
    };
  },
  perimeters: [operatorsPerimeter],
  computed: {
    filteredOperators() {
      return this.operators.filter(item =>
        item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1,
      );
    },
  },
  created() {
    this.fetchOperators();
    this.fetchERR();
  },
  beforeMount() {
    this.refreshReloaAppStatus();
  },
  methods: {
    fetchOperators() {
      kexaApi.get_operators()
        .then((data) => {
          this.operators = data.body;
        });
    },
    fetchERR() {
      kexaApi.err().then((data) => { this.err = data.body; });
    },
    loadOperator(operator) {
      this.operator = operator;
      this.action = 'update';
      this.modalShow = true;
    },
    createOperator() {
      this.operator = {};
      this.action = 'create';
      this.modalShow = true;
    },
    registerOperator() {
      kexaApi.create_operator(this.operator)
        .then(() => {
          this.modalShow = false;
          this.fetchOperators();
        });
    },
    updateOperator() {
      kexaApi.update_operator(this.operator, this.operator.id)
        .then(() => {
          this.action = null;
          this.modalShow = false;
          this.fetchOperators();
        });
    },
    closeModal() {
      this.action = null;
      this.modalShow = false;
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
  .operatorModal .form-horizontal .form-group { min-width: auto; }
</style>



// WEBPACK FOOTER //
// src/components/Operators.vue